import React, { useState, useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from './components/home';
import Events from './components/Events';
import Profile from './components/Profile';
import NxlStats from './components/NxlStats';
import NxlSchedule from './components/NxlSchedule';
import PrivacyRequestPage from './components/PrivacyRequestPage';
import Loading from './components/Loading';
import './App.css';

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 1800);
    return () => clearTimeout(timer);
  }, []);

  if (loading) return <Loading />;

  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/events" element={<Events />} />
        <Route path="/v/:venueSlug/events" element={<Events />} />
        <Route path="/nxl" element={<NxlStats />} />
        <Route path="/nxl/schedule" element={<NxlSchedule />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/privacy" element={<PrivacyRequestPage />} />
      </Routes>
    </div>
  );
}

export default App;
